import _classCallCheck from "/home/runner/work/v2/v2/webapp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/v2/v2/webapp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/home/runner/work/v2/v2/webapp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/home/runner/work/v2/v2/webapp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/runner/work/v2/v2/webapp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/v2/v2/webapp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _wrapNativeSuper from "/home/runner/work/v2/v2/webapp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.
import { isError } from "@azure/core-util";
import { custom } from "./util/inspect.js";
import { Sanitizer } from "./util/sanitizer.js";
var errorSanitizer = new Sanitizer();
/**
 * A custom error type for failed pipeline requests.
 */

export var RestError = /*#__PURE__*/function (_Error) {
  _inherits(RestError, _Error);

  var _super = _createSuper(RestError);

  function RestError(message) {
    var _this;

    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, RestError);

    _this = _super.call(this, message);
    _this.name = "RestError";
    _this.code = options.code;
    _this.statusCode = options.statusCode; // The request and response may contain sensitive information in the headers or body.
    // To help prevent this sensitive information being accidentally logged, the request and response
    // properties are marked as non-enumerable here. This prevents them showing up in the output of
    // JSON.stringify and console.log.

    Object.defineProperty(_assertThisInitialized(_this), "request", {
      value: options.request,
      enumerable: false
    });
    Object.defineProperty(_assertThisInitialized(_this), "response", {
      value: options.response,
      enumerable: false
    });
    Object.setPrototypeOf(_assertThisInitialized(_this), RestError.prototype);
    return _this;
  }
  /**
   * Logging method for util.inspect in Node
   */


  _createClass(RestError, [{
    key: custom,
    value: function value() {
      // Extract non-enumerable properties and add them back. This is OK since in this output the request and
      // response get sanitized.
      return "RestError: ".concat(this.message, " \n ").concat(errorSanitizer.sanitize(Object.assign(Object.assign({}, this), {
        request: this.request,
        response: this.response
      })));
    }
  }]);

  return RestError;
}( /*#__PURE__*/_wrapNativeSuper(Error));
/**
 * Something went wrong when making the request.
 * This means the actual request failed for some reason,
 * such as a DNS issue or the connection being lost.
 */

RestError.REQUEST_SEND_ERROR = "REQUEST_SEND_ERROR";
/**
 * This means that parsing the response from the server failed.
 * It may have been malformed.
 */

RestError.PARSE_ERROR = "PARSE_ERROR";
/**
 * Typeguard for RestError
 * @param e - Something caught by a catch clause.
 */

export function isRestError(e) {
  if (e instanceof RestError) {
    return true;
  }

  return isError(e) && e.name === "RestError";
}